// src/prototype/exports/downloadHelper.ts
// ============================================================
// DOWNLOAD HELPER
// Utilities for triggering file downloads in the browser.
// ============================================================

/**
 * Triggers a download of a Blob as a file
 */
export function downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  
  /**
   * Triggers a download of text content as a file
   */
  export function downloadText(text: string, filename: string, mimeType: string = 'text/plain'): void {
    const blob = new Blob([text], { type: mimeType });
    downloadBlob(blob, filename);
  }
  
  /**
   * Triggers a download of JSON as a file
   */
  export function downloadJSON(data: unknown, filename: string): void {
    const text = JSON.stringify(data, null, 2);
    downloadText(text, filename, 'application/json');
  }
  
  /**
   * Triggers a download of CSV content
   */
  export function downloadCSV(csvContent: string, filename: string): void {
    downloadText(csvContent, filename, 'text/csv');
  }
  
  /**
   * Generates a timestamp string for filenames
   */
  export function getTimestamp(): string {
    const now = new Date();
    return now.toISOString().split('T')[0]; // YYYY-MM-DD
  }
  
  /**
   * Generates a formatted timestamp for display
   */
  export function getDisplayTimestamp(): string {
    return new Date().toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
  
  /**
   * Builds a standardized filename
   * Format: DVA_<clientNameOrId>_<Deliverable>_<YYYY-MM-DD>.<ext>
   */
  export function buildFilename(
    clientIdentifier: string,
    deliverableType: string,
    extension: string
  ): string {
    const timestamp = getTimestamp();
    const sanitizedClient = clientIdentifier.replace(/[^a-zA-Z0-9]/g, '');
    const sanitizedDeliverable = deliverableType.replace(/\s+/g, '_');
    return `DVA_${sanitizedClient}_${sanitizedDeliverable}_${timestamp}.${extension}`;
  }